import React from 'react';

import StorefrontIcon from '@mui/icons-material/Storefront';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import GroupsIcon from '@mui/icons-material/Groups';
import ApartmentIcon from '@mui/icons-material/Apartment';

import FeedIcon from '@mui/icons-material/Feed';
import { Option } from '../interfaces';
import { ROUTES } from '@routes/routes';

export const mainMenuOptions: Option[] = [
  {
    key: 'feed',
    link: '/',
    icon: <FeedIcon />,
    inProduction: true,
  },
  {
    key: 'news',
    link: '/news',
    icon: <NewspaperIcon />,
    inProduction: true,
  },
  {
    key: 'events',
    icon: <CalendarMonthIcon />,
    link: ROUTES.portal.events.overview,
  },
  {
    key: 'duty-schedule',
    icon: <EventAvailableIcon />,
    link: ROUTES.portal.dutySchedule.overview,
  },
  {
    key: 'groups',
    icon: <GroupsIcon />,
  },
  {
    key: 'photos',
    icon: <PhotoLibraryIcon />,
    link: '/photos',
    subItems: [
      {
        key: 'photos-all',
        link: '/photos',
      },
      {
        key: 'photos-albums',
      },
      // {
      //   key: 'photos-favorites',
      //   label: 'Favorieten',
      // },
    ],
  },
  {
    key: 'competitions',
    icon: <EmojiEventsIcon />,
    link: '/competitions',
    inProduction: true,
    subItems: [
      {
        key: 'feed',
        link: '/competitions/feed',
        inProduction: true,
      },
      {
        key: 'current-competitions',
        link: '/competitions/current',
        inProduction: true,
      },
      {
        key: 'results',
        link: '/competitions/results',
        inProduction: true,
      },
    ],
  },
  {
    key: 'training',
    icon: <MilitaryTechIcon />,
  },
  {
    key: 'marketplace',
    icon: <StorefrontIcon />,
  },
  {
    key: 'forum',
    icon: <QuestionAnswerIcon />,
  },
  {
    key: 'association',
    icon: <ApartmentIcon />,
    link: '/association',
    subItems: [
      {
        key: 'about',
        link: '/association/about',
        inProduction: true,
      },
      {
        key: 'board-members',
        link: '/association/board-members',
        inProduction: true,
      },
      {
        key: 'disciplines',
        link: '/association/disciplines',
        inProduction: true,
      },
      {
        key: 'forms',
        link: '/association/forms',
      },
      {
        key: 'rulesAndRegulations',
        link: '/association/regulations-and-safety',
        inProduction: true,
      },
      {
        key: 'instructions',
        link: '/association/instructions',
        inProduction: true,
      },
      // {
      //   key: 'general_meeting',
      //   label: 'Algemene leden vergadering',
      // },
      // {
      //   key: 'jobs',
      //   label: 'Vacatures',
      // },
      {
        key: 'ideas',
        link: '/association/ideas',
      },
      // {
      //   key: 'timeline',
      //   label: 'Tijdslijn',
      //   link: '/association/timeline',
      // },
    ],
  },
  {
    key: 'faq',
    icon: <QuestionMarkIcon />,
    link: 'news2',
  },
];
